module.exports = __webpack_public_path__ + "static/Iris versicolor (Northern blue flag)-7e9d31aec9ccabaf27515e1a9aebe975.jpg";